import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home/Home.vue";
import Home2 from "./views/Home/Home2.vue";
import Suscribe from "./views/Home/Suscribe.vue";
import FAQ from "@/views/FAQ";
import TestPage from "@/views/Home/TestPage";
import Kickstarter from "@/views/Home/Kickstarter";
import Confirm from "@/views/Confirm";
import Giveaway from "./views/Home/Giveaway.vue";
import embedWidget from "./components/embedWidget.vue";
import Referral from "./views/Referral/Referral.vue";
import ReferralTiers from "./views/Referral/ReferralTiers.vue";
import ReferralDashboard from "./views/Referral/ReferralDashboard.vue";
import Links from "./views/Links.vue"

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    }, 
    {
      path: "/home",
      name: "Home2",
      component: Home2
    },
    {
      path: "/giveaway",
      name: "Giveaway",
      component: Giveaway
    },
    {
      path: "/embedwidget",
      name: "embedWidget",
      component: embedWidget
    },
    {
      path: "/subscribe",
      name: "Home",
      component: Home
    },
    {
      path: "/faq",
      name: "FAQ",
      component: FAQ
    },
    {
      path: "/testpage",
      name: "TestPage",
      component: TestPage
    },
    {
      path: "/kickstarter",
      name: "Kickstarter",
      component: Kickstarter
    },
    {
      path: "/suscribe",
      name: "Suscribe",
      component: Suscribe
    },
    {
      path: "/confirm",
      name: "Confirm",
      component: Confirm
    },
    {
      path: "/referral",
      name: "Referral",
      component: Referral
    },
    {
      path: "/referral-tiers",
      name: "ReferralTiers",
      component: ReferralTiers
    },
    {
      path: "/cn-links",
      name: "Links",
      component: Links
    },
    {
      //path: "/referral-dashboard/:id",
      path: "/referral-dashboard",
      name: "ReferralDashboard",
      component: ReferralDashboard
    },
    {
      path: "*",
      redirect: "/"
    }
  ],
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});



// WEBPACK FOOTER //
// ./src/router.js